import React, { useState, useLayoutEffect } from "react";
import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TableSortLabel,
  Badge,
  Chip,
  Button,
  Collapse,
  ClickAwayListener,
  Popper,
  Card,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  capitalizeFirstLetter,
  getEllipsisName,
} from "../../utils/generalUtils";
import moment from "moment";
import { ReactComponent as DeleteIcon } from "Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import { ReactComponent as CollectionIcon } from "../../Assets/Icons/PharmsmartIcon/CollectionIcon.svg";
import { ReactComponent as ViewRxIcon } from "../../Assets/Icons/PharmsmartIcon/ViewRxIcon.svg";
import { ReactComponent as NoteIcon } from "../../Assets/Icons/PharmsmartIcon/NoteIcon.svg";
import useViewport from "../../Hooks/useViewport";
import "../../Sass/Common.scss";
import { ReactComponent as Clock } from "../../Assets/Icons/PharmsmartIcon/Clock.svg";
import clsx from "clsx";
import ChaseUpDialog from "./ChaseUpDialog";
import CollectDialog from "../../Components/Collection/CollectDialog";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import TableTabPagination from "Components/Common/TableTabPagination";
import Chips from "../../Components/Common/Chips";
import { ReactComponent as EditIcon } from "../../Assets/Icons/PharmsmartIcon/EditIcon.svg";

import { ReactComponent as ArchiveIcon } from "../../Assets/Icons/PharmsmartIcon/ArchiveIcon.svg";

import { useDispatch } from "react-redux";
import { START_COLLECT_MARK_AS_URGENT } from "../../Actions/CollectionAction";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import FilterListIcon from "@mui/icons-material/FilterList";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";


const useStyle = makeStyles((theme) => ({
  rsUrgentIconBtn: {
    border: "3 solid",
    borderRadius: "3px !important",
    // borderRadius: "10px !important",
    fontSize: "10px !important",
    // height: "20px !important",
    height: "24px !important",
    // marginLeft: "3px !important",
    marginRight: "3px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "white",
    display: "flex",
    alignItems: "center",
    cursor: "auto",
    "&>span": {
      fontSize: "10px",
      padding: "8px 8px 7px",
      fontWeight: "600 !important",
      color: "white",
      cursor: "auto",
    },
    [theme.breakpoints.down(1500)]: {
      marginLeft: "0 !important",
      marginTop: "3px",
    },
  },
  rsUrgentIconBtnNot: {
    border: "3 solid",
    borderRadius: "5px !important",
    // borderRadius: "10px !important",
    fontSize: "10px !important",
    // height: "20px !important",
    height: "24px !important",
    // marginLeft: "3px !important",
    marginRight: "3px",
    marginTop: "8px",
    marginBottom: "8px",
    color: "white",
    display: "flex",
    alignItems: "center",
    cursor: "auto",
    "&>span": {
      fontSize: "10px",
      padding: "8px 8px 7px",
      fontWeight: "600 !important",
      color: "white",
      cursor: "auto",
    },

    [theme.breakpoints.down(1500)]: {
      marginLeft: "0 !important",
      marginTop: "3px",
    },
  },
  tableHead: {
    "&>tr": {
      whiteSpace: "nowrap !important",
      "&>th": {
        lineHeight: "0.6rem",
        [theme.breakpoints.down(1500)]: {
          padding: "16px 13px !important",
        },
        whiteSpace: "nowrap !important",
        " &:nth-child(3)": {
          width: "18%",
        },
        "&:first-child": {
          minWidth: "20%",
          [theme.breakpoints.down(1400)]: {
            width: "16%",
          },
        },
        "&:last-child": {
          width: "0% !important",
        },
      },
    },
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        whiteSpace: "nowrap !important",
        [theme.breakpoints.down(1400)]: {
          padding: "2px 14px !important",
        },
        " &:nth-child(3)": {
          whiteSpace: "nowrap !important",
          [theme.breakpoints.down(1400)]: {
            padding: "2px 27px !important",
          },
          [theme.breakpoints.down(1500)]: {
            padding: "2px 10px !important",
          },
        },
        " &:nth-child(5)": {
          [theme.breakpoints.down(1400)]: {
            padding: "2px 12px !important",
          },
        },
      },
    },
  },
  tableBodyArchive: {
    "&>tr": {
      background: "#F7F7F8 !important",

      "&>td": {
        background: "#F7F7F8 !important",

        whiteSpace: "nowrap !important",
        [theme.breakpoints.down(1400)]: {
          padding: "2px 14px !important",
        },
        " &:nth-child(5)": {
          [theme.breakpoints.down(1400)]: {
            padding: "2px 31px !important",
          },
        },
      },
    },
  },
  rsPatientInfo: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    width: "250px !important",
    [theme.breakpoints.down(1500)]: {
      display: "block",
    },
  },
  iconClock: {
    marginBottom: "-2px",
    "&:hover": {
      cursor: "pointer",
    },
  },
  textInfo: {
    paddingBottom: "8px !important",
  },
  cursor: {
    cursor: "pointer !important",
  },
  rsHtmlToolTip: {
    cursor: "pointer !important",
  },
  rsGridDate: {
    // marginBottom: "5px !important",
    display: "flex",
  },
  iconStyle: {
    display: "flex",
    alignItems: "end",
    marginLeft: "2px",
    marginBottom: "3px",
  },
  rsPatientNameAlign: {
    display: "flex",
    marginRight: "8px",
    color: "#464646 !important",
    "&:hover": {
      color: "rgba(90, 104, 114, 0.8) !important",
      cursor: "pointer",
    },
  },
  rsPatientNameAlignActive: {
    marginRight: "8px",
    height: "30px",
    alignItems: "center",
    display: "flex",
    color: "#464646 !important",
    "&:hover": {
      color: "rgba(90, 104, 114, 0.8) !important",
      cursor: "pointer",
    },
  },
  rsIconFilterDispense: {
    // marginTop: "2px",
    top: "0px !important",
    "&>div": {
      "&>svg": {
        width: "20px",
        height: "20px",
      },
    },
  },
  rsiconBtn: {
    display: "flex",
    position: "relative",
  },
  rsActiveIconBtn: {
    display: "flex",
    background: theme.palette.primary.main,
    height: "8px",
    width: "8px",
    borderRadius: "5px",
    marginTop: "8px",
    marginLeft: "5px",
    position: "absolute",
    left: "12px",
    top: "3px",
  },
  rsTableCellHeader: {
    display: "flex",
    "&>span": {
      height: "19px",
    },
  },
  rsPopperPage: {
    zIndex: "14",
    padding: "7px 21px 9px",
    backgroundColor: "white",
    position: "absolute",
    // top: "215px !important",
    // left: "200px !important",
    borderRadius: "10px",
    width: "150px",
    boxShadow:
      "0px 8px 15px rgba(110, 117, 130, 0.15), 0px 1px 2px rgba(110, 117, 130, 0.3)",
    [theme.breakpoints.down(1300)]: {
      // width: "15%",
    },
    [theme.breakpoints.down(1200)]: {
      top: "257px !important",
    },
    [theme.breakpoints.down(1100)]: {
      // width: "20%",
    },
    [theme.breakpoints.down(800)]: {
      // width: "23%",
    },
    [theme.breakpoints.down(769)]: {
      width: "180px",
      left: "100px !important",
      top: "260px !important",
    },
    [theme.breakpoints.down(651)]: {
      top: "300px !important",
    },
    [theme.breakpoints.down(601)]: {
      top: "330px !important",
    },
  },
  rsFilterlistview: {
    "&>li": {
      display: "block",
      marginBottom: "10px",
      marginTop: "10px",
      "&>svg": {
        top: "5px",
        position: "relative",
      },
    },
  },
  managePageHUser: {
    "& .MuiTableContainer-root": {
      // maxHeight: "calc(94vh - 200px) !important",
      paddingLeft: "13px !important",
      paddingRight: "13px !important",
      [theme.breakpoints.down(1145)]: {
        maxHeight: "calc(100vh - 225px) !important",
        paddingLeft: "0px !important",
        paddingRight: "0px !important",
      },
      [theme.breakpoints.down(409)]: {
        maxHeight: "calc(100vh - 245px) !important",
        paddingLeft: "0px !important",
        paddingRight: "0px !important",
      },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              padding: "10.5px 16px",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              "&:first-child": {
                // position: "sticky",
                // left: 0,
                [theme.breakpoints.down(1300)]: {
                  zIndex: 13,
                },
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                // left: 0,
                zIndex: 1,
              },
              " &:nth-child(3)": {
                position: "sticky",
                // left: 0,
                // right: 0,
                zIndex: 1,
              },
              " &:nth-child(4)": {
                position: "sticky",
                // left: 0,
                zIndex: 1,
                // right: "-30px",
              },
              " &:nth-child(5)": {
                position: "sticky",
                // right: "-16px",
                zIndex: 1,
                // left: 0,
              },
              " &:nth-child(6)": {
                position: "sticky",
                alignContent: "center",
                // right: 0,
                zIndex: 3,
              },
              " &:nth-child(7)": {
                position: "sticky",
                // right: "-12px",
                zIndex: 3,
              },
              "&:last-child": {
                position: "sticky",
                // right: 0,
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "relative",
                // left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "relative",
                // left: 0,
                zIndex: 0,
              },
              " &:nth-child(4)": {
                position: "relative",
                // left: 0,
                // right: "-30px",
                zIndex: 0,
              },
              " &:nth-child(5)": {
                position: "relative",
                // right: "-16px",
                zIndex: 0,
                // left: 0,
              },
              " &:nth-child(3)": {
                position: "relative",
                // left: 0,
                zIndex: 0,
                // right: 0,
              },
              " &:nth-child(6)": {
                position: "relative",
                alignContent: "center",
                // right: 0,
                zIndex: 2,
              },
              " &:nth-child(7)": {
                position: "relative",
                // right: "-12px",
                zIndex: 2,
              },
              "&:last-child": {
                background: "#ffffff",
                position: "relative",
                // right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  managePageH: {
    "& .MuiTableContainer-root": {
      maxHeight: "calc(95vh - 163px) !important",
      padding: "0px !important",
      // [theme.breakpoints.down(1400)]: {
      //   maxHeight: "calc(92vh - 200px) !important",
      // },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              padding: "10.5px 16px",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              "&:first-child": {
                position: "sticky",
                left: 0,
                zIndex: 4,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              " &:nth-child(3)": {
                position: "sticky",
                left: 0,
                right: 0,
                zIndex: 1,
              },
              " &:nth-child(4)": {
                position: "sticky",
                left: 0,
                zIndex: 1,
                right: "-30px",
              },
              " &:nth-child(5)": {
                position: "sticky",
                right: "-16px",
                zIndex: 1,
                left: 0,
              },
              " &:nth-child(6)": {
                position: "sticky",
                alignContent: "center",
                right: 0,
                zIndex: 3,
              },
              " &:nth-child(7)": {
                position: "sticky",
                right: "-12px",
                zIndex: 3,
              },
              "&:last-child": {
                position: "sticky",
                right: 0,
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                left: 0,
                zIndex: 0,
              },
              " &:nth-child(4)": {
                position: "sticky",
                left: 0,
                right: "-30px",
                zIndex: 0,
              },
              " &:nth-child(5)": {
                position: "sticky",
                right: "-16px",
                zIndex: 0,
                left: 0,
              },
              " &:nth-child(3)": {
                position: "sticky",
                left: 0,
                zIndex: 0,
                right: 0,
              },
              " &:nth-child(6)": {
                position: "sticky",
                alignContent: "center",
                right: 0,
                zIndex: 2,
              },
              " &:nth-child(7)": {
                position: "sticky",
                right: "-12px",
                zIndex: 2,
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  managePageH2: {
    "& .MuiTableContainer-root": {
      maxHeight: "calc(103vh - 331px) !important",
      padding: "0px !important",
      // [theme.breakpoints.down(1400)]: {
      //   maxHeight: "calc(92vh - 200px) !important",
      // },
      "&>table": {
        "&>thead": {
          "&>tr": {
            "&>th": {
              padding: "10.5px 16px",
              borderBottom: "3px solid #dddddd",
              borderLeft: "3px solid #dddddd",
              "&:first-child": {
                position: "sticky",
                left: 0,
                zIndex: 4,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                left: 0,
                zIndex: 1,
              },
              " &:nth-child(3)": {
                position: "sticky",
                left: 0,
                right: 0,
                zIndex: 1,
              },
              " &:nth-child(4)": {
                position: "sticky",
                left: 0,
                zIndex: 1,
                right: "-30px",
              },
              " &:nth-child(5)": {
                position: "sticky",
                right: "-16px",
                zIndex: 1,
                left: 0,
              },
              " &:nth-child(6)": {
                position: "sticky",
                alignContent: "center",
                right: 0,
                zIndex: 3,
              },
              " &:nth-child(7)": {
                position: "sticky",
                right: "-12px",
                zIndex: 3,
              },
              "&:last-child": {
                position: "sticky",
                right: 0,
                zIndex: 4,
              },
            },
          },
        },
        "&>tbody": {
          "&>tr": {
            "&>td": {
              "&:first-child": {
                background: "#ffffff",
                position: "sticky",
                left: "0px",
                zIndex: 3,
              },
              " &:nth-child(2)": {
                borderLeft: "none !important",
                position: "sticky",
                left: 0,
                zIndex: 0,
              },
              " &:nth-child(4)": {
                position: "sticky",
                left: 0,
                right: "-30px",
                zIndex: 0,
              },
              " &:nth-child(5)": {
                position: "sticky",
                right: "-16px",
                zIndex: 0,
                left: 0,
              },
              " &:nth-child(3)": {
                position: "sticky",
                left: 0,
                zIndex: 0,
                right: 0,
              },
              " &:nth-child(6)": {
                position: "sticky",
                alignContent: "center",
                right: 0,
                zIndex: 2,
              },
              " &:nth-child(7)": {
                position: "sticky",
                right: "-12px",
                zIndex: 2,
              },
              "&:last-child": {
                background: "#ffffff",
                position: "sticky",
                right: "0px",
                padding: "0px 3px !important",
                zIndex: 3,
              },
            },
          },
        },
      },
    },
  },
  rsIconStatus: {
    cursor: "auto",
    "&>div": {
      marginLeft: "10px !important",
    },
  },
  rseditDateIcon: {
    padding: "0px !important",
    width: "18px",
    height: "18px",
    "&>svg": {
      // marginLeft: 10,
      display: "none",
    },
  },
  rsOrderDate: {
    "&>div": {
      height: "25px !important",
      borderRadius: "3px !important",
      lineHeight: "31px !important",
      "&:hover": {
        // background: "rgba(123, 192,  68,0.08) !important",
      },
    },
    "&:hover": {
      lineHeight: "20px",
      cursor: "pointer",
      "&>button": {
        padding: "0px !important",
        "&:hover": {
          backgroundColor: "transparent !important",
          border: `none !important`,
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  groupColorIcon: {
    padding: "8px",
    margin: "3px",
    width: "10px",
    height: "8px",
    borderRadius: "3px !important",
  },
  rsArchive: {
    fill: "black !important",
  },
  rsUrgentTag: {
    whiteSpace: "nowrap",
    "&>div": {
      "&>div": {
        "&>div": {
          "&>button": {
            paddingLeft: "3px !important",
            paddingRight: "3px !important",
            paddingTop: "0px !important",
            paddingBottom: "0px !important",
            // display: "block",
            display: "none",
            height: "20px !important",
            marginLeft: "5px",
            fontSize: "11px",
            fontWeight: "500",
            "&:hover": {
              // backgroundColor: "transparent !important",
              // border: `none !important`,
              display: "block",
            },
            "&>svg": {
              display: "block",
            },
          },
        },
      },
    },
    "&:hover": {
      cursor: "pointer",
      "&>div": {
        display: "block",
        // "&>button": {
        //   paddingLeft: "3px !important",
        //   paddingRight: "3px !important",
        //   paddingTop: "0px !important",
        //   paddingBottom: "0px !important",
        //   display: "block",
        //   height: "30px",
        //   fontSize: "11px",
        //   fontWeight: "500",
        //   "&:hover": {
        //     // backgroundColor: "transparent !important",
        //     // border: `none !important`,
        //     display: "block",
        //   },
        //   "&>svg": {
        //     display: "block",
        //   },
        // },
        "&>div": {
          "&>div": {
            "&>button": {
              paddingLeft: "3px !important",
              paddingRight: "3px !important",
              paddingTop: "0px !important",
              paddingBottom: "0px !important",
              display: "block",
              height: "30px",
              fontSize: "11px",
              fontWeight: "500",
              "&:hover": {
                // backgroundColor: "transparent !important",
                // border: `none !important`,
                display: "block",
              },
              "&>svg": {
                display: "block",
              },
            },
            "&>div": {
              // "&>div": {
              "&>span": {
                display: "none",
              },
              // },
            },
          },
        },
      },
    },
  },
  rsUrgentbtn: {
    lineHeight: "20px",
    // display: "none",
    "&>svg": {
      marginLeft: "13px",
      display: "none",
      height: "18px",
      width: "18px",
    },
  },
  collectIcon: {
    "&>path": {
      fill: "rgb(123, 192, 68)",
    },
  },
  cardGroup: {
    background: "#AED581",
    borderRadius: "3px",
    margin: "0px",
    padding: "2px",
    color: "white",
    height: "20px",
    fontSize: "10px",
    padding: "4px 8px",
    fontWeight: "600 !important",
  },
  rsTable: {
    position: "relative",
    clear: "both",
    // marginTop: "5px"
  },
  rsmarkUrgentTag: {
    // display:"none",
    "&:hover": {
      whiteSpace: "nowrap",
      "&>button": {
        // paddingLeft: "3px !important",
        // paddingRight: "3px !important",
        // paddingTop: "0px !important",
        // paddingBottom: "0px !important",
        display: "block",
        height: "30px",
        fontSize: "11px",
        fontWeight: "500",
        "&:hover": {
          // backgroundColor: "transparent !important",
          // border: `none !important`,
          display: "block",
        },
        "&>svg": {
          display: "block",
        },
      },
    },
  },
  labelContainer: {
    display: "flex",
    flexDirection: "row",
  },
  tableContainer: {
    height: "auto",
  },
  hoverAlign: {
    padding: "0px 5px !important",
  },
}));

const UnCollectedTable = (props) => {
  const {
    collectionRxList,
    setDeleteCollectionDetails,
    setCollectionDeleteId,
    setTarget,
    setIsOpenViewRx,
    setCollectionActionType,
    collectedUncollectedListShow,
    setCollectAndUncollectedViewRxDetails,
    setShowCollectedNoteList,
    setOpenCollectedNoteList,
    setCollectedUncollectedListShow,
    collectionViewRxAction,
    collectionViewRxDetails,
    collectAndUncollectedViewRxDetails,
    selectedNoteDetails,
    setSelectedNoteDetails,
    createChaseUpDetails,
    UpdateChaseUp,
    defaultColumnOrderBy,
    columnSortingOrder,
    setColumnSortingOrder,
    chaseUpActiveStatus,
    HtmlTooltipMain,
    showDataBasedOnRole,
    getList,
    resetCollectionRxState,
    tableCells,
    getHomeListAction,
    setEditDobDate,
    setIsOpenEditDobModel,
    archive,
    openViewOrder,
    setOpenViewOrder,
    openFaxOrder,
    setOpenFaxOrder,
    phone,
    setPhone,
    fax,
    setFax,
    setNoteId,
    handleDeleteNote,
    deleteSingleNote,
    addAndUpdateNoteAction,
    addAndUpdateNote,
    getArchiveCollectionAction,
    patientDetailOpen,
    setPatientDetailOpen,
    patientId,
    setPatientId,
    urgentFilter,
    setUrgentFilter,
    readyToCollect,
    setReadyToCollect,
    checked,
    setChecked,
    loginUserDetail,
    subscriptionDialog,
    setSubscritionDialog,
    setViewOrderData,
    isPrescriptionTracking,
    currentPage,
    onPageChange,
  } = props;
  const classes = useStyle();
  const { width } = useViewport();
  const [openCollect, setOpenCollect] = useState(false);
  const [unCollectedTooltipMessages, setUnCollectedTooltipMessages] = useState(
    {}
  );
  const [popperAnchorEl, setPopperAnchorEl] = React.useState(null);

  const [reordertitle, setReordertitle] = useState(false);
  const showLoaderValue = Object.values(tableCells).filter((item) => {
    return item;
  });
  const [uncollectedHoverRecordId, setUncollectedHoverRecordId] =
    useState(null);
  const [chaseUpDialog, setChaseUpDialog] = useState(false);
  const [collect, setCollect] = useState(false);

  const dispatch = useDispatch();
  const HoverUncollectedCountShow =
    collectionViewRxDetails?.data?.patient_medications
      ?.map((item) => {
        return item?.status === "Not collected"
          ? `${item?.drug_name}${"\r\n"}`
          : "";
      })
      ?.join("\n ");

  /** get api data */
  useLayoutEffect(() => {
    if (uncollectedHoverRecordId) {
      let message = "";
      if (collectionViewRxDetails?.loading) {
        message = "Please wait...";
      } else {
        message = HoverUncollectedCountShow;
      }
      setUnCollectedTooltipMessages({
        ...unCollectedTooltipMessages,
        [uncollectedHoverRecordId]: message,
      });
    }
  }, [
    collectionViewRxDetails?.data?.patient_medications,
    uncollectedHoverRecordId,
  ]);
  const handleUrgent = (id, status) => {
    // if (loginUserDetail?.data?.data?.is_expired) {
    //   setSubscritionDialog(true);
    // } else {
    dispatch({
      type: START_COLLECT_MARK_AS_URGENT,
      id: id,
      payload: {
        is_urgent: status,
      },
    });
    // }
  };

  /** Helper function to render outstanding days tag with color coding */
  const getOutstandingDaysTag = (item) => {
    const days = item?.outstanding_days;
    if (days === undefined || days === null || days === "") return null;

    const numDays = Number(days);
    if (isNaN(numDays)) return null;

    let label = "";
    let color = ""; // Background color
    let textColor = ""; // Text color
    let borderColorChip = "";

    if (numDays < 0) {
      label = "Overdue";
      color = "#FDE8E8";
      textColor = "#E53935";
      borderColorChip = "#FDE8E8";
    } else if (numDays < 10) {
      label = `${numDays} ${numDays === 1 ? "day" : "days"}`;
      color = "#EDF7ED";
      textColor = "#2E7D32";
      borderColorChip = "#EDF7ED";
    } else if (numDays >= 10 && numDays < 15) {
      label = `${numDays} days`;
      color = "#FFF4E5";
      textColor = "#D97706";
      borderColorChip = "#FFF4E5";
    } else {
      // numDays >= 15 (e.g. 19 days, 31 days)
      label = `${numDays} days`;
      color = "#FFF4E5";
      textColor = "#D97706";
      borderColorChip = "#FFF4E5";
    }

    return (
      <Chips
        label={label}
        color={color}
        textColor={textColor}
        borderColorChip={borderColorChip}
        variant="filled"
        width="auto"
      />
    );
  };
  /**applied filter in the icon  */
  const handleIconFilterChange = (e) => {
    setPopperAnchorEl(e.currentTarget);
    setChecked((prev) => !prev);
  };
  /**handle click Away in filter dropdown */
  const handleClickAway = () => {
    setChecked(false);
  };
  return (
    <Grid>
      <Grid
        className={clsx(
          classes.rsTable,
          width < 1200
            ? // && showDataBasedOnRole === "user"
            classes.managePageHUser
            : width < 769 &&
              ["admin", "pharmacist_staff", "pharmacist", "pharmacy"].indexOf(
                showDataBasedOnRole
              ) !== -1
              ? ""
              : isPrescriptionTracking ? classes.managePageH2 : classes.managePageH
        )}
      >
        <TableContainer>
          <Table stickyHeader className={classes.tableContainer}>
            <TableHead className={classes.tableHead}>
              <TableRow>
                {Object.keys(tableCells).map((headCell) => (
                  <>
                    {tableCells[headCell].show && (
                      <>
                        {tableCells[headCell].sortable === true ? (
                          <TableCell
                            key={tableCells[headCell].id}
                            align="center"
                            padding={
                              tableCells[headCell].disablePadding
                                ? "none"
                                : "normal"
                            }
                          >
                            <Box className={classes.rsTableCellHeader}>
                              <TableSortLabel
                                sx={{
                                  "&.MuiTableSortLabel-root": {
                                    color: "white",
                                  },
                                  "& .MuiTableSortLabel-icon": {
                                    color:
                                      columnSortingOrder.orderBy ===
                                        tableCells[headCell].id
                                        ? "#525252 !important"
                                        : "#C5C5C5 !important",
                                    "&.MuiTableSortLabel-iconDirectionDesc": {
                                      color: "#525252 !important",
                                    },
                                    "& .MuiTableSortLabel-iconDirectionAsc": {
                                      color:
                                        columnSortingOrder.orderBy ===
                                          tableCells[headCell].id
                                          ? "#525252 !important"
                                          : "#C5C5C5 !important",
                                    },
                                  },
                                }}
                                className="tableSort"
                                direction={
                                  columnSortingOrder.orderBy ===
                                    tableCells[headCell].id
                                    ? columnSortingOrder.sortBy
                                    : defaultColumnOrderBy
                                }
                                onClick={(e) => {
                                  setColumnSortingOrder({
                                    orderBy: tableCells[headCell].id,
                                    sortBy:
                                      (columnSortingOrder.orderBy ===
                                        tableCells[headCell].id
                                        ? columnSortingOrder.sortBy
                                        : defaultColumnOrderBy) === "desc"
                                        ? "asc"
                                        : "desc",
                                  });
                                }}
                              >
                                <Box display="inline-flex" alignItems="center">
                                  <span>{tableCells[headCell].label == "ITEMS" ? isPrescriptionTracking ? tableCells[headCell].label : "UNCOLLECTED" : tableCells[headCell].label}</span>
                                  {(tableCells[headCell].tooltip ||
                                    tableCells[headCell].infoTooltip ||
                                    headCell === "uncollected_count" ||
                                    headCell === "outstanding_days") && isPrescriptionTracking && (
                                      <HtmlTooltipMain
                                        title={
                                          tableCells[headCell].tooltip ||
                                          tableCells[headCell].infoTooltip ||
                                          (headCell === "uncollected_count"
                                            ? "Number of uncollected medication items"
                                            : headCell === "outstanding_days"
                                              ? "Number of days since the prescription order was placed. (If the record is created from the Rx, the outstanding days are not displayed.)"
                                              : "")
                                        }
                                        placement="top"
                                        sx={{
                                          maxWidth: 'auto !important',
                                        }}
                                      >
                                        <Box
                                          component="span"
                                          display="inline-flex"
                                          alignItems="center"
                                          marginLeft="4px"
                                          onClick={(e) => e.stopPropagation()}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <HelpOutlineIcon
                                            style={{
                                              fontSize: "14px",
                                              color: "inherit",
                                              opacity: 0.85,
                                            }}
                                          />
                                        </Box>
                                      </HtmlTooltipMain>
                                    )}
                                </Box>
                              </TableSortLabel>
                              <>
                                {tableCells[headCell].icons === true &&
                                  !archive && (
                                    <Box
                                      className={classes.rsIconFilterDispense}
                                    >
                                      <Box className={classes.rsiconBtn}>
                                        <FilterListIcon
                                          className="cursor-pointer"
                                          onClick={(e) =>
                                            handleIconFilterChange(e)
                                          }
                                        />
                                        {(urgentFilter === true ||
                                          readyToCollect === true) && (
                                            <Box
                                              className={classes.rsActiveIconBtn}
                                            ></Box>
                                          )}
                                      </Box>
                                      <Box>
                                        <Popper
                                          open={checked}
                                          placement={"bottom"}
                                          anchorEl={popperAnchorEl}
                                          className={classes.rsPopperPage}
                                        >
                                          <ClickAwayListener
                                            onClickAway={handleClickAway}
                                          >
                                            <Collapse in={checked}>
                                              <ul
                                                className={
                                                  classes.rsFilterlistview
                                                }
                                              >
                                                <li
                                                  className="cursor-pointer"
                                                  onClick={(e) => {
                                                    setUrgentFilter(
                                                      !urgentFilter
                                                    );
                                                  }}
                                                >
                                                  <Chips
                                                    label="Urgent"
                                                    color={
                                                      urgentFilter
                                                        ? "rgba(255, 0, 0,0.6) "
                                                        : ""
                                                    }
                                                    variant={
                                                      urgentFilter
                                                        ? "filled"
                                                        : "outlined"
                                                    }
                                                    borderColorChip={
                                                      urgentFilter
                                                        ? ""
                                                        : "rgba(255, 0, 0,1)"
                                                    }
                                                    textColor={
                                                      urgentFilter
                                                        ? "white"
                                                        : "rgba(255, 0, 0,1)"
                                                    }
                                                    border={
                                                      urgentFilter ? "" : "3"
                                                    }
                                                    width="100px"
                                                  />
                                                </li>
                                                <li
                                                  className={classes.rsCursor}
                                                  onClick={(e) => {
                                                    setReadyToCollect(
                                                      !readyToCollect
                                                    );
                                                  }}
                                                >
                                                  <Chips
                                                    label="Ready to collect"
                                                    color={
                                                      readyToCollect
                                                        ? "rgba(123, 192, 68,0.6) "
                                                        : ""
                                                    }
                                                    variant={
                                                      readyToCollect
                                                        ? "filled"
                                                        : "outlined"
                                                    }
                                                    borderColorChip={
                                                      readyToCollect
                                                        ? ""
                                                        : "rgba(123, 192, 68,1)"
                                                    }
                                                    textColor={
                                                      readyToCollect
                                                        ? "white"
                                                        : "rgba(123, 192, 68,1)"
                                                    }
                                                    border={
                                                      readyToCollect ? "" : "3"
                                                    }
                                                    width="100px"
                                                  />
                                                </li>
                                              </ul>
                                            </Collapse>
                                          </ClickAwayListener>
                                        </Popper>
                                      </Box>
                                    </Box>
                                  )}
                              </>
                            </Box>
                          </TableCell>
                        ) : (
                          <TableCell>
                            <Box display="inline-flex" alignItems="center">
                              <span>{tableCells[headCell].label}</span>
                              {(tableCells[headCell].tooltip ||
                                tableCells[headCell].infoTooltip ||
                                headCell === "uncollected_count" ||
                                headCell === "outstanding_days") && (
                                  <HtmlTooltipMain
                                    title={
                                      tableCells[headCell].tooltip ||
                                      tableCells[headCell].infoTooltip ||
                                      (headCell === "uncollected_count"
                                        ? "Number of uncollected medication items"
                                        : headCell === "outstanding_days"
                                          ? "Number of days since the prescription order was placed. (If the record is created from the Rx, the outstanding days are not displayed.)"
                                          : "")
                                    }
                                    placement="top"
                                  >
                                    <Box
                                      component="span"
                                      display="inline-flex"
                                      alignItems="center"
                                      marginLeft="4px"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <HelpOutlineIcon
                                        style={{
                                          fontSize: "14px",
                                          color: "inherit",
                                          opacity: 0.85,
                                        }}
                                      />
                                    </Box>
                                  </HtmlTooltipMain>
                                )}
                            </Box>
                          </TableCell>
                        )}
                      </>
                    )}
                  </>
                ))}
              </TableRow>
            </TableHead>
            <TableBody
              className={archive ? classes.tableBodyArchive : classes.tableBody}
            // style={
            //   collectionRxList?.loading && collectionRxList?.data?.list?.length
            //     ? { opacity: 0.65, pointerEvents: "none", transition: "opacity 0.15s ease" }
            //     : { transition: "opacity 0.15s ease" }
            // }
            >
              {collectionRxList?.loading && !collectionRxList?.data?.list?.length ? (
                <TableCellLoader
                  cells={
                    showLoaderValue.filter(({ show }) => show === true).length
                  }
                />
              ) : collectionRxList?.data?.list?.length > 0 ? (
                collectionRxList?.data?.list?.map((item, i) => {
                  return (
                    <TableRow key={i}>
                      <TableCell semiBold className={classes.rsUrgentTag}>
                        <Box className={classes.iconContainer}>
                          <Box className={classes.rsPatientInfo}>
                            <Box
                              className={
                                item?.chase_up_status || item?.ready_to_collect
                                  ? classes.rsPatientNameAlignActive
                                  : classes.rsPatientNameAlign
                              }
                              onClick={() => {
                                setCollectionActionType("viewRxUnCollected");
                                // setIsOpenViewRx(true);
                                // setCollectAndUncollectedViewRxDetails(item?.id);
                                setPatientDetailOpen(true);
                                setPatientId(item?.patient_id);
                                setCollectedUncollectedListShow("un_collected");
                              }}
                            >
                              {capitalizeFirstLetter(item?.name)}{" "}
                              {capitalizeFirstLetter(item?.last_name)}
                            </Box>
                            <Box className={classes.labelContainer}>
                              {item?.status == 0 && !archive && (
                                <Button
                                  className={classes.rsUrgentbtn}
                                  variant="contained"
                                  onClick={() => {
                                    handleUrgent(item?.id, true);
                                  }}
                                >
                                  Mark urgent
                                </Button>
                              )}
                              {item?.status == 1 && !archive && (
                                <Button
                                  className={classes.rsUrgentbtn}
                                  variant="contained"
                                  onClick={() => {
                                    handleUrgent(item?.id, false);
                                  }}
                                >
                                  Mark not urgent
                                </Button>
                              )}
                              <Box className={classes.rsIconStatus}>
                                <span>
                                  {item?.status == 1 && !archive && (
                                    <>
                                      {" "}
                                      <Box
                                        className={clsx("urgent_effect")}
                                      ></Box>
                                      <Box>
                                        <Chips
                                          label="Urgent"
                                          color={"#e9514e"}
                                          variant="filled"
                                          textColor="white"
                                          borderColorChip="#e9514e"
                                          className={classes.rsUrgentIconBtn}
                                          width="58px"
                                        // onClick={() => {
                                        //   handleUrgent();
                                        // }}
                                        />
                                      </Box>
                                    </>
                                    // <Chip
                                    //   className={classes.rsUrgentIconBtn}
                                    //   label="Urgent"
                                    //   style={{
                                    //     backgroundColor: "red",
                                    //     cursor: "auto",
                                    //   }}
                                    // />
                                  )}
                                </span>
                              </Box>
                            </Box>
                          </Box>
                          <Box
                            display="flex"
                            marginBottom="3px"
                            marginTop="3px"
                          >
                            {item?.group?.g_tag ? (
                              <Box
                                display="flex"
                                style={{
                                  background: item?.group?.g_color_code,
                                }}
                                // paddingLeft="5px"
                                className={classes.cardGroup}
                              >
                                {/* {` (`} */}
                                {/* <Card
                                    className={classes.groupColorIcon}
                                    style={{
                                      background: item?.group?.g_color_code,
                                    }}
                                  /> */}
                                {` ${item?.group?.g_tag}`}
                                {/* {`)`} */}
                              </Box>
                            ) : (
                              ""
                            )}

                            {item?.ready_to_collect === true && !archive ? (
                              <Chips
                                label="Ready to Collect"
                                color="rgba(123, 192, 68,0.6)"
                                onClick={() => {
                                  if (showDataBasedOnRole !== "user") {
                                    setCollect(true);
                                    setChaseUpDialog(true);
                                    setCollectionActionType(
                                      "viewRxUnCollected"
                                    );
                                    setCollectAndUncollectedViewRxDetails(
                                      item?.id
                                    );
                                    setCollectedUncollectedListShow(
                                      "un_collected"
                                    );
                                  }
                                }}
                              />
                            ) : (
                              <></>
                            )}
                            <>
                              {item?.chase_up_status && !archive ? (
                                <Chips
                                  label="Chase Up"
                                  color="rgba(28, 128, 221, 0.6)"
                                  onClick={() => {
                                    if (showDataBasedOnRole !== "user") {
                                      setChaseUpDialog(true);
                                      setCollectionActionType(
                                        "viewRxUnCollected"
                                      );
                                      setCollectAndUncollectedViewRxDetails(
                                        item?.id
                                      );
                                      setCollectedUncollectedListShow(
                                        "un_collected"
                                      );
                                    }
                                  }}
                                />
                              ) : (
                                <></>
                              )}
                            </>

                            {/* <Box className={classes.rsmarkUrgentTag}>
                              {item?.status == 0 && !archive && (
                                <Button
                                  className={classes.rsUrgentbtn}
                                  variant="contained"
                                  onClick={() => {
                                    handleUrgent(item?.id, true);
                                  }}
                                >
                                  Mark urgent
                                </Button>
                              )}
                            </Box> */}
                          </Box>
                        </Box>
                      </TableCell>

                      {Object.keys(tableCells).map((columnName) => {
                        return (
                          <>
                            {tableCells[columnName].show && (
                              <>
                                {columnName === "dob" && (
                                  <TableCell className={classes.rsOrderDate}>
                                    {item?.dob
                                      ? moment(new Date(item?.dob)).format(
                                        "DD-MM-YYYY"
                                      )
                                      : // "N / A"
                                      showDataBasedOnRole === "user"
                                        ? "N / A"
                                        : !item?.dob && (
                                          <>
                                            <Box className="addme_effect"></Box>
                                            <Chips
                                              // className={classes.rsAddme}
                                              label="Add me"
                                              color={"rgba(123, 192,  68,1)"}
                                              variant={"filled"}
                                              // color={""}
                                              // variant={"outlined"}
                                              textColor={"rgba(255,255,255,1)"}
                                              borderColorChip={
                                                "rgba(123, 192,  68,1)"
                                              }
                                              // textColor={"rgba(123, 192, 68,1)"}
                                              width="58px"
                                              onClick={() => {
                                                setEditDobDate(item);
                                                setIsOpenEditDobModel(true);
                                              }}
                                            />
                                          </>
                                        )}
                                    {` `}
                                    {showDataBasedOnRole !== "user" && (
                                      <>
                                        {item?.dob && (
                                          <IconButton
                                            className={classes.rseditDateIcon}
                                          >
                                            <PrimaryIcon
                                              color="white"
                                              width="20px"
                                              icon={EditIcon}
                                              cursor="pointer"
                                              onClick={() => {
                                                // setIsOrderRecordActionType("editOrderDate");
                                                setEditDobDate(item);
                                                setIsOpenEditDobModel(true);
                                              }}
                                            />
                                          </IconButton>
                                        )}
                                      </>
                                    )}
                                  </TableCell>
                                )}
                                {columnName === "surgery_name" && (
                                  <TableCell>
                                    <HtmlTooltipMain
                                      className={classes.rsHtmlToolTip}
                                      title={item?.surgery_name}
                                    >
                                      <span className={classes.textInfo}>
                                        {width > 1600
                                          ? getEllipsisName(
                                            item?.surgery_name,
                                            30
                                          )
                                          : getEllipsisName(
                                            item?.surgery_name,
                                            18
                                          )}
                                      </span>
                                    </HtmlTooltipMain>
                                  </TableCell>
                                )}
                                {columnName === "created_user_type" && (
                                  <TableCell>
                                    {/* <HtmlTooltipMain
                                      title={item?.order_by}
                                      className={clsx(
                                        classes.textInfo,
                                        classes.rsHtmlToolTip
                                      )}
                                    > */}
                                    <span>
                                      {item?.created_by?.name
                                        ? capitalizeFirstLetter(
                                          item?.created_by?.name
                                        )
                                        : item?.order_by}
                                    </span>
                                    {/* </HtmlTooltipMain> */}
                                  </TableCell>
                                )}
                                {columnName === "uncollected_count" && (
                                  <TableCell className={classes.cursor}>
                                    <HtmlTooltipMain
                                      title={
                                        <React.Fragment>
                                          <ul>
                                            {item?.medication_type ===
                                              "specific"
                                              ? item?.uncollected_medications
                                                ?.length !== 0
                                                ? item?.uncollected_medications?.map(
                                                  (item) => {
                                                    return (
                                                      <li>
                                                        {item?.drug_name}
                                                      </li>
                                                    );
                                                  }
                                                )
                                                : ""
                                              : item?.medication_type ===
                                                "number"
                                                ? `Total medication: ${item?.number_of_medication}`
                                                : "?"}
                                          </ul>
                                        </React.Fragment>
                                      }
                                    >
                                      <Grid>
                                        {item?.medication_type === "specific"
                                          ? item?.uncollected_count
                                          : item?.medication_type === "number"
                                            ? // ||
                                            item?.number_of_medication
                                            : "?"}
                                      </Grid>
                                    </HtmlTooltipMain>
                                  </TableCell>
                                )}
                                {columnName === "created_at" && (
                                  <TableCell>
                                    <Grid
                                      title={
                                        moment(
                                          new Date(item?.created_at)
                                        ).format("DD-MM-YYYY") || "N / A"
                                      }
                                      className={clsx(
                                        classes.cursor,
                                        classes.rsGridDate
                                      )}
                                    >
                                      {moment(
                                        new Date(item?.created_at)
                                      ).format("Do MMM") || "N / A"}
                                    </Grid>

                                    <Grid className={classes.rsGridDate}>
                                      <span
                                        className={classes.cursor}
                                        title={
                                          moment(
                                            new Date(item?.reorder_date)
                                          ).format("DD-MM-YYYY") || "N / A"
                                        }
                                      >
                                        {item?.reorder_date
                                          ?.slice(-1)
                                          .map((items) => {
                                            let temp = moment(
                                              new Date(items)
                                            ).format("Do MMM");
                                            return `${temp}${" "}`;
                                          })}
                                      </span>
                                      <HtmlTooltipMain
                                        className={classes.rsHtmlToolTip}
                                        title={
                                          <React.Fragment>
                                            <ul>
                                              <li>
                                                {item?.reorder_date?.length > 1
                                                  ? "Reorder dates"
                                                  : "Reorder date"}
                                              </li>
                                              {item?.reorder_date?.map(
                                                (items) => {
                                                  let temp = moment(
                                                    new Date(items)
                                                  ).format("DD-MM-YYYY");
                                                  return <li>{temp}</li>;
                                                }
                                              )}
                                            </ul>
                                          </React.Fragment>
                                        }
                                      >
                                        <span className={classes.iconStyle}>
                                          {"  "}
                                          {item?.is_reopen ? (
                                            <Clock
                                              className={classes.iconClock}
                                              width="15px"
                                              height="15px"
                                            />
                                          ) : (
                                            ""
                                          )}
                                        </span>
                                      </HtmlTooltipMain>
                                    </Grid>
                                  </TableCell>
                                )}
                                {columnName === "pharmacy_name" && (
                                  <TableCell>
                                    {item?.pharmacy_name || "-"}
                                  </TableCell>
                                )}
                                {columnName === "outstanding_days" && (
                                  <TableCell>
                                    {item?.outstanding_days && item?.outstanding_days !== '-' ? getOutstandingDaysTag(item) : '-'}
                                  </TableCell>
                                )}
                              </>
                            )}
                          </>
                        );
                      })}
                      <TableCell>
                        <Box
                          display={"flex"}
                          style={archive ? { justifyContent: "center" } : {}}
                          fontWeight="300"
                        >
                          {!archive && (
                            <>
                              <HtmlTooltipMain
                                title="View Note"
                                onClick={() => {
                                  setShowCollectedNoteList(item);
                                  setOpenCollectedNoteList(true);
                                  setSelectedNoteDetails(item);
                                }}
                              >
                                {item?.note !== null ? (
                                  <IconButton className={classes.hoverAlign}>
                                    <Badge
                                      color="red"
                                      variant="dot"
                                      sx={{
                                        "& .MuiBadge-badge": {
                                          zIndex: "auto",
                                          background: "red"
                                        },
                                      }}
                                    >
                                      <PrimaryIcon
                                        height="19px"
                                        icon={NoteIcon}
                                        cursor="pointer"
                                        color="white"
                                      />
                                    </Badge>
                                  </IconButton>
                                ) : (
                                  <IconButton className={classes.hoverAlign}>
                                    <PrimaryIcon
                                      height="19px"
                                      icon={NoteIcon}
                                      cursor="pointer"
                                      color="white"
                                    />
                                  </IconButton>
                                )}
                              </HtmlTooltipMain>
                              <HtmlTooltipMain
                                title={
                                  isPrescriptionTracking
                                    ? "Chase Up"
                                    : "Reorder"
                                }
                              >
                                <IconButton
                                  className={classes.hoverAlign}
                                  onClick={() => {
                                    setChaseUpDialog(true);
                                    setCollectionActionType(
                                      "viewRxUnCollected"
                                    );
                                    setCollectAndUncollectedViewRxDetails(
                                      item?.id
                                    );
                                    setCollectedUncollectedListShow(
                                      "un_collected"
                                    );
                                    setReordertitle(true);
                                  }}
                                >
                                  <PrimaryIcon
                                    height="21px"
                                    icon={ViewRxIcon}
                                    cursor="pointer"
                                  />
                                </IconButton>
                              </HtmlTooltipMain>
                              <HtmlTooltipMain
                                title={
                                  "Mark Rx As Arrived"
                                }
                              >
                                <IconButton
                                  className={classes.hoverAlign}
                                  onClick={() => {
                                    setOpenCollect(true);
                                    setCollectAndUncollectedViewRxDetails(
                                      item?.id
                                    );
                                    setSelectedNoteDetails(item);
                                  }}
                                >
                                  <PrimaryIcon
                                    height="19px"
                                    icon={CollectionIcon}
                                    cursor="pointer"
                                    className={classes.collectIcon}
                                  />
                                </IconButton>
                              </HtmlTooltipMain>
                            </>
                          )}
                          {showDataBasedOnRole !== "user" && (
                            <>
                              {archive ? (
                                <HtmlTooltipMain title="Unarchive">
                                  <IconButton
                                    className={classes.hoverAlign}
                                    onClick={() => {
                                      setDeleteCollectionDetails(true);
                                      setCollectionDeleteId(item?.id);
                                      let payLoad = {
                                        id: item?.id,
                                        is_archive: false,
                                      };
                                      // getArchiveCollectionAction(payLoad);
                                    }}
                                  >
                                    <PrimaryIcon
                                      width="20px"
                                      height="20px"
                                      className={classes.rsArchive}
                                      icon={UnarchiveOutlinedIcon}
                                      cursor="pointer"
                                    />
                                  </IconButton>
                                </HtmlTooltipMain>
                              ) : (
                                <HtmlTooltipMain title="Archive">
                                  <IconButton
                                    style={{
                                      lineHeight: "20px",
                                      // width: "45px",
                                      height: "45px",
                                    }}
                                    className={classes.hoverAlign}
                                    onClick={() => {
                                      let payLoad = {
                                        id: item?.id,
                                        is_archive: true,
                                      };
                                      setDeleteCollectionDetails(true);
                                      setCollectionDeleteId(item?.id);
                                      // getArchiveCollectionAction(payLoad);
                                    }}
                                  >
                                    <PrimaryIcon
                                      className={classes.rsArchive}
                                      width="20px"
                                      height="20px"
                                      icon={ArchiveIcon}
                                      cursor="pointer"
                                    />
                                  </IconButton>
                                </HtmlTooltipMain>
                              )}
                            </>
                          )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableEmptyState />
              )}
              {collectionRxList?.data?.list?.length <
                collectionRxList?.data?.filterd_record && (
                  <TableLoadMore setRef={setTarget} />
                )}
            </TableBody>
          </Table>
        </TableContainer>
        {/* {isPrescriptionTracking && (
          <TableTabPagination
            currentPage={currentPage}
            totalItems={collectionRxList?.data?.filterd_record || 0}
            itemsPerPage={10}
            onPageChange={onPageChange}
            label="outstanding prescriptions"
          />
        )} */}
      </Grid>
      <CollectDialog
        open={openCollect}
        setOpen={setOpenCollect}
        collectionViewRxAction={collectionViewRxAction}
        collectionViewRxDetails={collectionViewRxDetails}
        collectAndUncollectedViewRxDetails={collectAndUncollectedViewRxDetails}
        getList={getList}
        collectedUncollectedListShow={collectedUncollectedListShow}
        selectedNoteDetails={selectedNoteDetails}
        setNoteId={setNoteId}
        handleDeleteNote={handleDeleteNote}
        deleteSingleNote={deleteSingleNote}
        addAndUpdateNoteAction={addAndUpdateNoteAction}
        addAndUpdateNote={addAndUpdateNote}
        subscriptionDialog={subscriptionDialog}
        setSubscritionDialog={setSubscritionDialog}
        loginUserDetail={loginUserDetail}
      />
      <ChaseUpDialog
        getList={getList}
        collect={collect}
        setCollect={setCollect}
        open={chaseUpDialog}
        setOpen={setChaseUpDialog}
        collectionViewRxAction={collectionViewRxAction}
        collectionViewRxDetails={collectionViewRxDetails}
        collectAndUncollectedViewRxDetails={collectAndUncollectedViewRxDetails}
        collectedUncollectedListShow={collectedUncollectedListShow}
        createChaseUpDetails={createChaseUpDetails}
        UpdateChaseUp={UpdateChaseUp}
        chaseUpActiveStatus={chaseUpActiveStatus}
        resetCollectionRxState={resetCollectionRxState}
        getHomeListAction={getHomeListAction}
        reordertitle={reordertitle}
        setReordertitle={setReordertitle}
        showDataBasedOnRole={showDataBasedOnRole}
        subscriptionDialog={subscriptionDialog}
        setSubscritionDialog={setSubscritionDialog}
        loginUserDetail={loginUserDetail}
      />
    </Grid >
  );
};

export default UnCollectedTable;
